import { z } from 'zod'

const PaymentTransactionSchema = z.object({
  id: z.number(),
  gig_id: z.number(),
  payout_id: z.string().nullable(),
  status: z.string(),
  amount: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  pay_after: z.string().nullable(),
  masked_account_number: z.string(),
  category: z.string(),
  account_type: z.string(),
  consolidation_id: z.number().nullable(),
})

export const PaymentTransactionsResponseSchema = z.object({
  payment_transactions: z.array(PaymentTransactionSchema),
})

type PaymentTransactionsResponse = z.infer<typeof PaymentTransactionsResponseSchema>

// TODO: Change fields from snake_case to camelCase (will involve updating deserialization function and changing all references to these fields)
export type PaymentTransactions = {
  payment_transactions: Array<{
    id: number
    gig_id: number
    payout_id: string | null
    status: string
    amount: number
    created_at: string
    updated_at: string
    pay_after: string | null
    masked_account_number: string
    category: string
    account_type: string
    consolidation_id: number | null
  }>
}

export function deserializePaymentTransactionData(data: unknown): PaymentTransactions {
  const validatedData = data as PaymentTransactionsResponse
  return {
    payment_transactions: validatedData.payment_transactions,
  }
}
